import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * @deprecated use element-ui from libs
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
